import type { GetAssetByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetAssetByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssetByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAssetByIdArgs = {
  id: string;
};

export const useGetAssetById = createQueryHook<
  UseGetAssetByIdArgs,
  GetAssetByIdResponseRow[],
  GetAssetByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.asset.assetById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ asset: data }),
  graphqlDocument: GetAssetByIdDocument,
  graphqlVariables: ({ id }) => ({ _eq: id }),
});
